import React from 'react';
import { Card, Icon, Button } from 'semantic-ui-react';
import { formatDateForDisplay } from '../../utils/formatDate';
import './VideoLibrary.css';

export function VideoCard({ video, canManage, onPlay, onEdit, onDelete }) {
    return (
        <Card>
            <Card.Content>
                <div
                    className="video-thumbnail"
                    onClick={() => onPlay(video)}
                    role="button"
                    tabIndex={0}
                    aria-label={`Play ${video.title}`}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onPlay(video);
                        }
                    }}
                >
                    {video.thumbnailUrl ? (
                        <img
                            src={video.thumbnailUrl}
                            alt={`Thumbnail for ${video.title}`}
                        />
                    ) : (
                        <div className="video-thumbnail-icon">
                            <Icon name="film" size="huge" />
                        </div>
                    )}
                </div>
                <Card.Header
                    className="video-card-header"
                    onClick={() => onPlay(video)}
                >
                    {video.title}
                </Card.Header>
                {video.description && (
                    <Card.Description>{video.description}</Card.Description>
                )}
                <Card.Meta>
                    {video.uploadedBy && <span>Uploaded by {video.uploadedBy}</span>}
                    {video.creationTime && (
                        <span className="video-meta-date">
                            {formatDateForDisplay(video.creationTime)}
                        </span>
                    )}
                </Card.Meta>
                {video.tags && video.tags.length > 0 && (
                    <div className="video-tags">
                        {video.tags.flatMap((tag) => {
                            try { const p = JSON.parse(tag); return Array.isArray(p) ? p : [tag]; }
                            catch { return [tag]; }
                        }).map((tag, i) => (
                            <span key={i} className="video-tag">
                                {tag}
                            </span>
                        ))}
                    </div>
                )}
            </Card.Content>
            <Card.Content extra>
                <Button
                    primary
                    size="mini"
                    icon
                    labelPosition="left"
                    onClick={() => onPlay(video)}
                >
                    <Icon name="play" />
                    Play
                </Button>
                {canManage && (
                    <>
                        <Button
                            size="mini"
                            icon
                            onClick={() => onEdit(video)}
                            title="Edit video"
                            className="video-action-btn"
                        >
                            <Icon name="edit" />
                        </Button>
                        <Button
                            size="mini"
                            color="red"
                            icon
                            onClick={() => onDelete(video)}
                            title="Delete video"
                            className="video-action-btn"
                        >
                            <Icon name="trash" />
                        </Button>
                    </>
                )}
            </Card.Content>
        </Card>
    );
}
